import React from 'react';
import PropTypes from 'prop-types';

import ResponsiveModalShell from '../ResponsiveModalShell';

/**
 * Self-managed sources (e.g. Kundendepot).
 *
 * The source component manages its own data, filtering and selection. It emits
 * the chosen products through the curried `onConfirmProductsClick` callback and
 * needs no modal footer of its own.
 */
function SelfManagedSelectionFlow({open, onClose, onSelectProducts, SourceComponent}) {
  // Curried to match the component's existing contract:
  //   onConfirmProductsClick(closeModal, products) => () => void
  const handleConfirmProductsClick = (closeModal, products) => () => {
    const success = onSelectProducts(products || [], []);
    if (!success) {
      return;
    }
    if (closeModal) {
      onClose();
    }
  };

  return (
    <ResponsiveModalShell open={open} onClose={onClose}>
      <SourceComponent onConfirmProductsClick={handleConfirmProductsClick} />
    </ResponsiveModalShell>
  );
}

SelfManagedSelectionFlow.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectProducts: PropTypes.func.isRequired,
  SourceComponent: PropTypes.elementType.isRequired,
};

export default SelfManagedSelectionFlow;
